import React from 'react';
import { Box, SxProps, Theme, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export type IColor =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'warning'
  | 'success'
  | 'draft'
  | 'info'
  | 'approved'
  | 'waitApproved'
  | 'disapproved';

interface Props {
  children: React.ReactNode;
  color: IColor;
  textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase' | 'full-width' | 'full-size-kana';
  sx?: SxProps<Theme>;
}

export const Label = ({ children, color = 'secondary', textTransform = 'uppercase', sx }: Props) => {
  const theme = useTheme();
  // const getColorStyles = (colorTheme: Theme): SxProps<Theme> => {
  //   const colorStyles: Record<IColor, SxProps<Theme>> = {
  //     primary: {
  //       color: colorTheme.palette.primary.main,
  //       backgroundColor: alpha(colorTheme.palette.primary.main, 0.25),
  //     },
  //     secondary: {
  //       color: colorTheme.palette.secondary.main,
  //       backgroundColor: alpha(colorTheme.palette.secondary.main, 0.25),
  //     },
  //     error: {
  //       color: colorTheme.palette.error.main,
  //       backgroundColor: alpha(colorTheme.palette.error.main, 0.25),
  //     },
  //     warning: {
  //       color: colorTheme.palette.warning.main,
  //       backgroundColor: alpha(colorTheme.palette.warning.main, 0.25),
  //     },
  //     success: {
  //       color: colorTheme.palette.success.main,
  //       backgroundColor: alpha(colorTheme.palette.success.main, 0.25),
  //     },
  //     draft: {
  //       color: colorTheme.palette.grey[600],
  //       backgroundColor: alpha(colorTheme.palette.grey[600], 0.25),
  //     },
  //     info: {
  //       color: colorTheme.palette.info.main,
  //       backgroundColor: alpha(colorTheme.palette.info.main, 0.25),
  //     },
  //     approved: {
  //       color: '#00d631',
  //       backgroundColor: alpha(colorTheme.palette.grey[900], 0.13),
  //     },
  //     waitApproved: {
  //       color: '#b5972b',
  //       backgroundColor: alpha(colorTheme.palette.grey[900], 0.11),
  //     },
  //     disapproved: {
  //       color: '#ff0000',
  //       backgroundColor: alpha(colorTheme.palette.grey[900], 0.8),
  //     },
  //   };

  //   return colorStyles[color];
  // };

  const colorStyles: Record<IColor, SxProps<Theme>> = {
    primary: {
      color: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.25),
    },
    secondary: {
      color: theme.palette.secondary.main,
      backgroundColor: alpha(theme.palette.secondary.main, 0.25),
    },
    error: {
      color: theme.palette.error.main,
      backgroundColor: alpha(theme.palette.error.main, 0.25),
    },
    warning: {
      color: theme.palette.warning.main,
      backgroundColor: alpha(theme.palette.warning.main, 0.25),
    },
    success: {
      color: theme.palette.success.main,
      backgroundColor: alpha(theme.palette.success.main, 0.25),
    },
    draft: {
      color: theme.palette.grey[600],
      backgroundColor: alpha(theme.palette.grey[600], 0.25),
    },
    info: {
      color: theme.palette.info.main,
      backgroundColor: alpha(theme.palette.info.main, 0.25),
    },
    approved: {
      color: '#00d631',
      backgroundColor: alpha(theme.palette.grey[900], 0.13),
    },
    waitApproved: {
      color: '#b5972b',
      backgroundColor: alpha(theme.palette.grey[900], 0.11),
    },
    disapproved: {
      color: '#ff0000',
      backgroundColor: alpha(theme.palette.grey[900], 0.8),
    },
  };

  return (
    <Box
      sx={{
        ...colorStyles[color],
        textTransform,
        padding: '2px 8px',
        borderRadius: '8px',
        display: 'inline-block',
        // ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default Label;
